<template>
<div>
  <div class="main-content">
    <PrivateHeader></PrivateHeader>
    <p v-if="!$route.query.edit">帮人报名</p>
    <p v-else>修改信息</p>
    <div class="change-info">
      <div class="upload-head">
        <div class="upload-btn">
          <Upload
            ref="upload_img"
            :action="upload_action"
            :data="form_params"
            :before-upload="handleBeforeUpload"
            :on-success="uploadSuccess"
            :on-error="uploadError"
            :max-size="500"
            :on-exceeded-size="uploadExceeded"
            :format="['jpg','jpeg','png']"
            :on-format-error="uploadFormatError"
            :show-upload-list="false"
          >
            <img :src="img_url" v-if="img_url" />
            <img :src="$store.state.static_img_url+'/img/default-head-img.png'" v-else />
          </Upload>
        </div>
        <div class="upload-tip">点击上传头像</div>
      </div>
      <Form ref="user_info"  :model="form_params" :rules="rule_list" label-position="top" >
        <FormItem prop="name" label="姓名">
          <Input v-model="form_params.name" placeholder="请输入您的姓名" autocomplete="off"></Input>
        </FormItem>
        <FormItem prop="spell_last_name" label="姓拼音">
          <Input v-model="form_params.spell_last_name" placeholder="姓拼音，如Wang" autocomplete="off"></Input>
        </FormItem>
        <FormItem prop="spell_first_name" label="名拼音">
          <Input v-model="form_params.spell_first_name" placeholder="名拼音，如Ming" autocomplete="off"></Input>
        </FormItem>
        <FormItem prop="mobile" label="手机号">
          <Input v-model="form_params.mobile" placeholder="请输入手机号" autocomplete="off"></Input>
        </FormItem>
        <FormItem prop="email" label="邮箱">
          <Input v-model="form_params.email" placeholder="请输入您的邮箱" autocomplete="off"></Input>
        </FormItem>
        <FormItem prop="province" label="所在省份">
          <Select v-model="form_params.province" placeholder="请选择省份">
            <Option value="">请选择</Option>
            <Option v-for="item in province" :value="item.id" :key="item.id">{{item.name}}</Option>
          </Select>
        </FormItem>
        <FormItem prop="city" label="所在市">
          <Select v-model="form_params.city" placeholder="请选择城市">
            <Option value="">请选择</Option>
            <Option v-for="item in city" :value="item.id" :key="item.id">{{item.name}}</Option>
          </Select>
        </FormItem>
        <FormItem prop="county" label="所在区/县">
          <Select v-model="form_params.county" placeholder="请选择区/县">
            <Option value="">请选择</Option>
            <Option v-for="item in county" :value="item.id" :key="item.id">{{item.name}}</Option>
          </Select>
        </FormItem>
        <FormItem prop="address" label="地址">
          <Input v-model="form_params.address" placeholder="请输入详细地址" autocomplete="off"></Input>
        </FormItem>
        <FormItem prop="organization" label="单位">
          <Input v-model="form_params.organization" placeholder="请输入您的单位" autocomplete="off"></Input>
        </FormItem>
        <FormItem prop="department" label="科室/部门">
          <Input v-model="form_params.department" placeholder="请输入您的科室/部门" autocomplete="off"></Input>
        </FormItem>
        <FormItem prop="department_phone" label="单位电话">
          <Input v-model="form_params.department_phone" placeholder="电话号码" autocomplete="off"></Input>
        </FormItem>
        <FormItem prop="hos_title_id" label="职称">
          <Select v-model="form_params.hos_title_id" placeholder="请选择职称">
            <Option value="">请选择</Option>
            <Option v-for="item in meta.hos_title" :value="item.id" :key="item.id">{{item.name}}</Option>
          </Select>
        </FormItem>
      </Form>
    </div>
    <div class="btn">
      <!-- <Button @click="cancel">取消</Button> -->
      <Button type="primary" @click="sumbitUserInfo">确定</Button>
    </div>
  </div>
</div>
</template>

<script>
import {
  getMeta,
  joinActivity, _joinActivity,
  updateUserActivity,_updateUserActivity
} from '../../service'
import PrivateHeader from '../../components/Headers/header2'
export default {
  components: {
    PrivateHeader
  },
  data() {
    return {
      upload_action: _joinActivity,
      meta: '',
      img_url: '',
      file: '',
      form_params: {
        activity_id: '',
        name: '',
        organization: '',
        spell_last_name: '',
        spell_first_name: '',
        department: '',
        mobile: '',
        department_area: '',
        department_phone: '',
        email: '',
        hos_title_id: '',
        province: '',
        city: '',
        county: '',
        address: '',
        entry_type: '1'
      },
      rule_list: {
        'name': [{ required: true, message: '请输入报名人的姓名', trigger: 'blur'}],
        'organization': [{ required: true, message: '请输入报名人的单位', trigger: 'blur'}],
        'spell_last_name': [{ required: true, message: '请输入姓拼音，如Wang', trigger: 'blur'}],
        'spell_first_name': [{ required: true, message: '请输入姓拼音，如Ming', trigger: 'blur'}],
        'department': [{ required: true, message: '请输入报名人的科室/部门', trigger: 'blur'}],
        'mobile': [
          { required: true, message: '请输入您的联系电话', trigger: 'blur'},
          {
            type: 'number',
            message: '手机号格式不正确',
            trigger: 'blur',
            transform(value) {
              let reg = /^1[3456789]\d{9}$/
              if (!reg.test(value)) {
                return false
              } else {
                return Number(value)
              }
            }
          }
        ],
        'email': [
          { required: true, message: '请输入报名人的邮箱', trigger: 'blur'},
          { type: 'email', message: '邮箱格式不对', trigger: 'blur'}
        ],
        'hos_title_id': [{ required: true, message: '请选择报名人的职称', trigger: 'change'}],
        'province': [{ required: true, message: '请选择省份', trigger: 'change'}],
        'city': [{ required: true, message: '请选择城市', trigger: 'change'}],
        'county': [{ required: true, message: '区/县', trigger: 'change'}],
        'address': [{ required: true, message: '请输入详细地址', trigger: 'blur'}]
      }
    }
  },
  computed: {
    user_key() {
      return this.$store.state.user_key
    },
    user() {
      return this.$store.state.user
    },
    img_req_url(){
      return this.$store.state.img_req_url
    },
    province() {
      let re_arr = []
      let arr = this.meta.area ? this.meta.area : []
      arr.map((a) => {
        if (a.region_type == 1) {
          re_arr.push(a)
        }
      })
      return re_arr
    },
    city() {
      let re_arr = []
      let arr = this.meta.area ? this.meta.area : []
      arr.map((a) => {
        if (a.region_type == 2 && a.pid == this.form_params.province) {
          re_arr.push(a)
        }
      })
      return re_arr
    },
    county() {
      let re_arr = []
      let arr = this.meta.area ? this.meta.area : []
      arr.map((a) => {
        if (a.region_type == 3 && a.pid == this.form_params.city) {
          re_arr.push(a)
        }
      })
      return re_arr
    }
  },
  methods: {
    handleBeforeUpload(file) {
      this.file = file //需要传给后台的file文件
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => {
        const _base64 = reader.result
        this.img_url = _base64 //将_base64赋值给图片的src，实现图片预览
      }
      return false //阻止图片继续上传，使得form表单提交时统一上传
    },
    async sumbitUserInfo() {
      this.$refs['user_info'].validate(async (valid) => {
        if (valid) {
          this.form_params.user_key = this.user_key
          if(this.file) { //有图片的时候通过upload组件上传
            this.$refs['upload_img'].post(this.file)
          } else { //没有图片的时候通过setUserInfo接口上传
            let res = ''
            if(this.$route.query.edit) {
              res = await updateUserActivity(this.form_params, (error) => {
                this.$Message.error('请求失败！')
              })
            } else{
              res = await joinActivity(this.form_params, (error) => {
                this.$Message.error('请求失败！')
              })
            }
            this.uploadSuccess(res)
          }
        }
      })
    },
    async getMeta() {
      let res = await getMeta({
        name: ['area', 'hos_title']
      }, (error) => {
        this.$Message.error('请求失败！')
      })
      if (res.status=="success") {
        this.$set(this.$data, 'meta', res.meta)
      } else {
        this.$Message.error(res.message)
      }
    },
    uploadSuccess (res) {
      if (res.status == "success") {
        if(this.$route.query.edit) {
          this.$Message.success('修改成功！')
          this.$router.go(-1)
        } else {
          this.$router.push({name: 'ApplySuccee'})
        }
      } else {
        this.$Message.error(res.message)
      }
    },
    uploadFormatError(res) {
      this.$Message.error("请上传正确的图片格式PNG/JPG/JPEG");
    },
    uploadExceeded() {
      this.$Message.error('上传的图片大小请限制500KB以内')
    },
    uploadError (res) {
      this.$Message.error(res.message)
    },
    cancel(){
      this.$router.go(-1);//返回上一层
    },

    getList(){ //获得上一个页面过来的数据
      if( this.$route.query.edit ){
        let info = this.$route.params.info
        this.form_params = info
        this.form_params.user_id = info.id
        this.img_url = info.head_path ?  this.$store.state.req_url + info.head_path : ''
        this.upload_action = _updateUserActivity
      }
    }
  },
  created() {
    this.form_params.activity_id = this.$store.state.activity_id
    this.getMeta()
    this.getList()
  }
}
</script>

<style lang="stylus" scoped>
.main-content
  background: #F8F8F8
  padding-top: .88rem
  > p
    font-size: .36rem
    font-weight: bold
    color: rgba(51,51,51,1)
    line-height: 22px
    padding: .32rem .32rem 0
  .change-info
    padding: .32rem
    .ivu-form
      margin-top: .6rem
      padding: .3rem .3rem .06rem
      background: #FFFFFF
      .ivu-form-item
        margin-bottom: .24rem
      >>> .ivu-form-item-label
        font-size: .28rem
        color: #999
        padding-right: 0
        padding-bottom: 0
      >>> .ivu-input
      >>> .ivu-select-selection
        border: 0
        border-radius: 0
        border-bottom: 1px solid #EEEEEE
        font-size: .28rem
        padding: .08rem 0
        color: #666
        &:focus
          box-shadow: none
      >>> .ivu-form-item-error-tip
        position: relative
    >>>.upload-head
      .ivu-upload
        width: 2rem
        height: 2rem
        border-radius: 1rem
        overflow: hidden
        margin: 0 auto
        img
          width: 2rem
          height: 2rem
      .upload-tip
        margin-top: .3rem
        text-align: center
        font-size: .32rem
        font-weight: 500
        color: #333333
        line-height: 1
  .btn
    padding: .48rem .28rem .8rem
    .ivu-btn
      width: 100%
      height: .88rem
      font-size: .32rem
      border-radius: .1rem
      &:focus
        box-shadow: none
      &.ivu-btn-default
        color: #999
        border-color: #999
      &.ivu-btn-primary
        color: #fff
        background: #E12222
        border-color: #E12222
</style>
